import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  px: 5,
  width: 1,
  flexGrow: 1,
  minHeight: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: 3,
  position: 'absolute',
  zIndex: 1000,
};
